import type { FC, SVGProps } from 'react';

export const PlusIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M9.99971 10V2C9.99971 0.895431 10.8952 0 11.9998 0C13.1043 0 13.9998 0.89543 13.9998 2V10H22C23.1045 10 24 10.8954 24 12C24 13.1046 23.1045 14 22 14C22 14 17.1241 14 13.9998 14C12.8952 14 13.9998 12.8954 13.9998 14C13.9998 17.1242 13.9998 22 13.9998 22C13.9998 23.1046 13.1043 24 11.9998 24C10.8952 24 9.99971 23.1046 9.99971 22V14H1.99955C0.89496 14 -0.000488281 13.1046 -0.000488281 12C-0.000488281 10.8954 0.89496 10 1.99955 10H9.99971Z"
    />
  </svg>
);

export const CloseIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7043 11.7045C11.3105 12.0984 10.672 12.0984 10.2782 11.7045L0.295359 1.72151C-0.0984527 1.32769 -0.0984529 0.689185 0.295358 0.295365C0.68917 -0.0984551 1.32766 -0.0984549 1.72147 0.295365L11.7043 10.2784C12.0981 10.6722 12.0981 11.3107 11.7043 11.7045Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7046 0.295451C12.0985 0.689271 12.0985 1.32778 11.7046 1.7216L1.72182 11.7046C1.32801 12.0985 0.689519 12.0985 0.295708 11.7046C-0.0981034 11.3108 -0.0981032 10.6723 0.295708 10.2785L10.2785 0.295452C10.6723 -0.0983682 11.3108 -0.0983684 11.7046 0.295451Z"
      fill="currentColor"
    />
  </svg>
);

export const ReplaceIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7061_7175)">
      <path
        d="M0.458328 1.83323V4.58323M0.458328 4.58323H3.20833M0.458328 4.58323L2.58499 2.58489C3.07759 2.09205 3.687 1.73203 4.35637 1.53841C5.02573 1.3448 5.73324 1.3239 6.41286 1.47768C7.09249 1.63145 7.72209 1.95488 8.24291 2.41779C8.76372 2.8807 9.15879 3.468 9.39124 4.12489M10.5417 9.16656V6.41656M10.5417 6.41656H7.79166M10.5417 6.41656L8.41499 8.41489C7.9224 8.90773 7.31299 9.26776 6.64362 9.46137C5.97426 9.65499 5.26675 9.67588 4.58713 9.52211C3.9075 9.36833 3.2779 9.0449 2.75708 8.58199C2.23626 8.11908 1.8412 7.53178 1.60874 6.87489"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7061_7175">
        <rect width="11" height="11" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EditIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DecreaseIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 1C9.5 1.55228 9.05229 2 8.5 2H1.5C0.947715 2 0.5 1.55228 0.5 1C0.5 0.447715 0.947715 0 1.5 0H8.5C9.05229 0 9.5 0.447715 9.5 1Z" />
  </svg>
);

export const IncreaseIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.25 4.25V1.25C4.25 0.835786 4.58579 0.5 5 0.5C5.41421 0.5 5.75 0.835786 5.75 1.25V4.25H8.75C9.16421 4.25 9.5 4.58579 9.5 5C9.5 5.41421 9.16421 5.75 8.75 5.75C8.75 5.75 6.92157 5.75 5.75 5.75C5.33579 5.75 5.75 5.33579 5.75 5.75C5.75 6.92157 5.75 8.75 5.75 8.75C5.75 9.16421 5.41421 9.5 5 9.5C4.58579 9.5 4.25 9.16421 4.25 8.75V5.75H1.25C0.835786 5.75 0.5 5.41421 0.5 5C0.5 4.58579 0.835786 4.25 1.25 4.25H4.25Z" />
  </svg>
);

export const WarningIcon: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.73995 1.97461C9.02305 0.540364 6.97695 0.540365 6.26005 1.97461L0.207883 14.0827C-0.438839 15.3766 0.50171 16.8989 1.94783 16.8989H14.0522C15.4983 16.8989 16.4388 15.3766 15.7921 14.0827L9.73995 1.97461ZM8.79313 11.393L9.01973 5.39561H6.92372L7.15032 11.393H8.79313ZM7.16165 14.2727C7.38069 14.4898 7.66016 14.5983 8.00005 14.5983C8.33239 14.5983 8.6043 14.4898 8.81579 14.2727C9.03483 14.0474 9.14436 13.7719 9.14436 13.4464C9.14436 13.1125 9.03483 12.8329 8.81579 12.6075C8.6043 12.3821 8.33239 12.2694 8.00005 12.2694C7.66016 12.2694 7.38069 12.3821 7.16165 12.6075C6.95016 12.8329 6.84441 13.1125 6.84441 13.4464C6.84441 13.7719 6.95016 14.0474 7.16165 14.2727Z"
      fill="#FF4646"
    />
  </svg>
);
